import type KybModulePolicyRepository from "@/core/administration/repositories/KybModulePolicyRepository";
import type {
  KybModulePolicy,
  KybModuleStatus,
} from "@/core/administration/entities/KybModulePolicy";
import { RepositoryResult } from "@/core/shared/types/RepositoryResult";
import { HttpClient } from "../../http/HttpClient";
import { ApiResponse } from "../../api/types/ApiResponse";
import { executeRequest } from "../../http/services/executeRequest/executeRequest";
import kybModulePolicyEndpoints from "../../api/kybModulePolicyEndpoints/kybModulePolicyEndpoints";

type KybModuleStatusDto = {
  enabled: boolean;
};

type KybModulePolicyDto = {
  enabled: boolean;
  updatedBy: string | null;
  updatedAt: string | null;
};

function mapPolicyDto(dto: KybModulePolicyDto): KybModulePolicy {
  return {
    enabled: dto.enabled,
    updatedBy: dto.updatedBy,
    updatedAt: dto.updatedAt,
  };
}

export default class KybModulePolicyRepositoryBackend
  implements KybModulePolicyRepository
{
  constructor(private readonly httpClient: HttpClient) {}

  getStatus(): Promise<RepositoryResult<KybModuleStatus>> {
    return executeRequest(
      () =>
        this.httpClient.get<ApiResponse<KybModuleStatusDto>>({
          url: kybModulePolicyEndpoints.status(),
          withAuth: true,
        }),
      (dto) => ({ enabled: dto.enabled }),
    );
  }

  getPolicy(): Promise<RepositoryResult<KybModulePolicy>> {
    return executeRequest(
      () =>
        this.httpClient.get<ApiResponse<KybModulePolicyDto>>({
          url: kybModulePolicyEndpoints.policy(),
          withAuth: true,
        }),
      mapPolicyDto,
    );
  }

  updatePolicy(enabled: boolean): Promise<RepositoryResult<KybModulePolicy>> {
    return executeRequest(
      () =>
        this.httpClient.put<ApiResponse<KybModulePolicyDto>, { enabled: boolean }>({
          url: kybModulePolicyEndpoints.policy(),
          body: { enabled },
          withAuth: true,
        }),
      mapPolicyDto,
    );
  }
}
